import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UserSearchConditionApiService {
    constructor(http) {
        this.http = http;
    }
    getStudentConditions() {
        return this.http.get('/api/user-search-conditions/student');
    }
    saveStudentCondition(condition) {
        return this.http.post('/api/user-search-conditions/student', condition);
    }
    deleteStudentCondition(id) {
        return this.http.delete(`/api/user-search-conditions/student/${id}`);
    }
}
UserSearchConditionApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserSearchConditionApiService_Factory() { return new UserSearchConditionApiService(i0.ɵɵinject(i1.HttpClient)); }, token: UserSearchConditionApiService, providedIn: "root" });
